module.exports = __webpack_public_path__ + "static/media/iphone2.7118c0ad.png";